module.exports = __webpack_public_path__ + "img/adriatic-apartments-web.e850346f.jpg";